<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'グループ・イベント管理'">
          <list-item :spanText="'Q. '" :text="'組織変更によるイベントへの影響について'" :urlName="'HelpAdmin1'"></list-item>
          <list-item :spanText="'Q. '" :text="'グループ内で表示されるメンバーの情報'" :urlName="'HelpAdmin2'"></list-item>
          <list-item :spanText="'Q. '" :text="'歩数イベントにおける異常データの回避方法'" :urlName="'HelpAdmin3'"></list-item>
          <list-item :spanText="'Q. '" :text="'アーカイブされたイベントの確認方法'" :urlName="'HelpAdmin99'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory71.vue